
import Input from 'components/fields/Input/Input';
import SendIcon from '@mui/icons-material/Send';
import { Box, CircularProgress, IconButton, LinearProgress, Paper, } from '@mui/material';
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import styles from './drawer.module.css'
import React, { useState } from 'react';
import { GeneralFetch } from 'Api/generalFetch/generalFetch';
import { useRecoilValue } from 'recoil';
import { DrawerSchema } from 'schemas';
import { useComments } from 'hooks/comments/useComments';
import CustomTooltip from 'components/toolTip/tooltip';
import imgg from '../../assets/safety/messages.jpg'

export default function Comments({ color, txtColor }) {
    const colors = ["#00B9AE", "#9888A5", "#2D3047", "#F15152"]
    const [formData, setFormData] = useState({})
    const [refreshKey, setRefreshKey] = useState(0)
    const { fetchData, loading } = GeneralFetch()
    const drawer = useRecoilValue(DrawerSchema)
    const { comments, loading: gettingComments } = useComments({ refreshKey })

    const onChange = (id, content) => {
        setFormData({ [id]: content })
    }

    async function send() {
        const comment = formData?.comentario?.trim()
        if (!comment || loading) return

        try {
            await fetchData({ comentario: comment, object: drawer?.object, object_id: drawer?.data?.objectId }, 'comment', 'post', 'comment')
            setRefreshKey(current => current + 1)
            setFormData({})
        } catch (_) {
            // GeneralFetch presents the error to the user.
        }
    }

    const getCommentColor = (comment, index) => {
        const seed = `${comment?.name || ''}-${comment?.id || index}`
        const hash = [...seed].reduce((total, character) => total + character.charCodeAt(0), 0)
        return colors[hash % colors.length]
    }

    return (
        <div>
            <MDBox
                mx={-1.5}
                mt={-1}
                py={1.5}
                px={1.5}
                variant="gradient"
                bgColor="success"
                borderRadius="lg"
                coloredShadow="dark"
                style={{ background: color, margin: "-10px 0 0 -10px" }}
            >
                <MDTypography variant="h6" color={txtColor} >
                    Comentários
                </MDTypography>
            </MDBox>
            <Paper className={styles.comentarios} >
                {
                    gettingComments && <Box sx={{ marginTop: "5px", overflow: "hidden", width: '100%', backgroundColor: "#fff", paddingBottom: "3px" }}>
                        <LinearProgress />
                    </Box>
                }

                {!gettingComments &&

                    <>
                        {comments?.length > 0 ?
                            <div className={styles.speechContainer} style={{ paddingTop: "10px" }} >
                                {
                                    comments.map((comment, index) => {
                                        return (
                                            <div key={comment?.id || `${comment?.name}-${index}`} className={styles.speechBubble} style={{ borderLeft: `solid 5px ${getCommentColor(comment, index)}` }}>
                                                <p>
                                                    {comment?.comentario}
                                                </p>
                                                <span>{comment?.name}</span>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                            :
                            <div>
                                <MDTypography style={{ fontSize: "17px", textAlign: "center" }} variant="h4" color="dark">
                                    Sem Comentários, adicione um!
                                </MDTypography>,
                                <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }} >
                                    <img style={{ width: "330px", height: "350px" }} src={imgg} />
                                </div>
                            </div>
                        }
                    </>
                }

                <div className={styles.inputContainer}>
                    <Input
                        fieldId={"comentario"}
                        placeholder={"Comentário"}
                        multiLine={true}
                        rows={4}
                        formData={formData}
                        type={'text'}
                        width={"100%"}
                        onChange={onChange}
                        disabled={drawer?.data?.estado === '3'}
                    />
                    <CustomTooltip child={
                        <IconButton aria-label="Enviar comentário" disabled={drawer?.data?.estado === '3' || !formData?.comentario?.trim() || loading} onClick={send} style={{ position: "absolute", bottom: "0", marginLeft: "-42px", marginBottom: "12px" }} >
                            {loading ? <CircularProgress size={"25px"} style={{ color: "blue" }} />
                                : <SendIcon style={{ color: "#1A73E8", opacity: drawer?.data?.estado === '3' ? 0.5 : 1 }} />}
                        </IconButton>}
                        title={"Enviar Comentário"}
                    />
                </div>
            </Paper>
        </div>
    )
}
